module.exports = __webpack_public_path__ + "media/images/lesson_5/sebastiao_saltitao-d844352bf8199031e628d46824362c11.png";